// extracted by mini-css-extract-plugin
export default {"title":"BlockFilter_title__PXvw0","filters_container":"BlockFilter_filters_container__kxVYC","filters":"BlockFilter_filters__BlCBG","buttons":"BlockFilter_buttons__u+xtT"};